import {Link} from "react-router-dom";
import "./styles/service.scss";
import { motion } from "framer-motion"

function Service() {
    
   

    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./serviceImg/servicebanner.jpg" alt=""/>
                </motion.div>
            </div>
            <div className="container-fluid bgb">
                    <div className="container">
                        <div className="cpasubnav">
                            <a href="#area"><div>服務區域</div></a>
                            <a href="#qa"><div>解題與發問</div></a>
                            <a href="#whycpa"><div>Why USCPA</div></a>
                            <a href="#com"><div>方案比較表</div></a>
                            <a href="#intro"><div>產品介紹</div></a>
                            <a href="#twus"><div>台美教材比較</div></a>
                        </div>
                    </div>
                </div>
            <div className="container">
                
                <div className="beckertitlename mt100 mb-5">獨一無二台灣在地化中文加值服務</div>
                <div className="container whycpa mb100">
                <div className="sixsq">
                    <div className="sqcard">
                        <div className="side mt-5">
                            <img src="./cpaImg/cpa_icon_01.svg" alt=""/>
                            <div className="fs-5">特聘中文專業講師</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-5">捷進特聘中文講師，每位皆為 Becker 學員，均成功通過美國 CPA 四科考試且具豐富職場經驗。
                            職業領域包含四大會計事務所、大型法律事務所、外資企業、電商平台、…等。</div>
                        </div>
                    </div>
                </div>
                <div className="sixsq">
                    <div className="sqcard">
                        <div className="side mt-5">
                            <img src="./cpaImg/cpa_icon_02.svg" alt=""/>
                            <div className="fs-5">申請流程顧問諮詢</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-3">購買美國 Becker CPA Exam Review 會計專業培訓教材，於軟體效期內，捷進針對 USCPA 考程提供 3 次免費顧問諮詢及文件檢核服務，主題包含：學歷認證、報名考試、預約考場，每次30分鐘。另有「考後申請執照」與「抵免台會考試」兩項內容可接受顧問預約申請。</div>
                        </div>
                    </div>
                </div>
                <div className="sixsq">
                    <div className="sqcard">
                        <div className="side mt-5">
                        <img src="./cpaImg/cpa_icon_03.svg"alt=""/>
                            <div className="fs-5">中文精華數位課程</div>
                        </div>
                        <div className="side back p-3">
                            <div className="fs-5 mt-5">捷進數位課程，是將面授課程同步數位化，針對商務人士、預備出國留學、公務出差、留學中短暫返台的學員，配合個人需求自主安排課程進度。
                            數位化學習設備採一人一機，課程內容可重覆聆聽也可加快學習速度，是最佳個人化課程服務。</div>
                        </div>
                    </div>
                </div>
                </div>
                <div className="container whycpa mb100">
                    <div className="sixsq">
                        <div className="sqcard">
                            <div className="side mt-5">
                            <img src="./cpaImg/cpa_icon_04.svg"alt=""/>
                                <div className="fs-5">中文精華面授課程</div>
                            </div>
                            <div className="side back p-3">
                                <div className="fs-5 mt-5">捷進中文講師針對台灣學生特別編寫講義、掌握重點、解析觀念，內容如濃縮成雞精般的精華，幫助學員有效吸收會計專業知識。
                                實體面授課程，小班教學機制，師生、同儕與捷進同仁交流互動，讓準備 USCPA 的你持續感受到鼓勵與支持。</div>
                            </div>
                        </div>
                    </div>
                    <div className="sixsq">
                        <div className="sqcard">
                                <div className="side mt-5">
                                    <img src="./cpaImg/cpa_icon_05.svg"alt=""/>
                                    <div className="fs-5">中文雲端學科導讀</div>
                                </div>
                                <div className="side back p-3">
                                    <div className="fs-5 mt-5">捷進為幫助非英語系國家考生能快速有效地進入學習狀態，請四大學科專業講師分析各科章節配比與重要內容、準備小撇步與時間規劃建議，幫助學員站穩學習第一步。</div>
                                </div>
                        </div>
                    </div>
                    <div className="sixsq">
                        <div className="sqcard">
                                <div className="side mt-5">
                                <img src="./cpaImg/cpa_icon_06.svg"alt=""/>
                                    <div className="fs-5">中文講師線上解題</div>
                                </div>
                                <div className="side back p-3">
                                    <div className="fs-5 mt-5">學員可於「中文線上發問區」用關鍵字搜尋歷史問答或新增提問，由台灣專業講師團隊、依各科專業領域線上解答。
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="br mt100 mb100"></div>
                <div className="container">
                <div className="row g-3">
                    <div className="col-3">
                    <a href="#why" className="btn btn-primary btn_len w-100">
                        <span className="lsn">比較各項方案</span>
                    </a>
                    </div>
                    <div className="col-3">
                    <a href="/share" className="btn btn-primary btn_len w-100">
                        <span className="lsn">華人考生心得</span>
                    </a>
                    </div>
                    <div className="col-3">
                    <a href="/consult" className="btn btn-primary btn_len w-100">
                        <span className="lsn">評估報考資格</span>
                    </a>
                    </div>
                    <div className="col-3">
                    <a href="https://line.me/R/ti/p/%40vtz1908l" target="_blank" rel="noreferrer" className="btn btn-primary btn_len w-100">
                        <span className="lsn">在線諮詢發問</span>
                    </a>
                    </div>
                </div>
                </div>
                <div className="container">
                    <h2 className="beckertitlename mt100 mb-5" id="area">可販售與付費寄送至以下國家</h2>

                    <div className="row mb-3">
                        <div className="col-sm-3 ctbox ctl text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p01.png" alt="USA" />
                            <p>USA</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p02.png" alt="Canada" />
                            <p>Canada</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p10.png" alt="Singapore" />
                            <p>Singapore</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p04.png" alt="Japan" />
                            <p>Japan</p>
                        </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-sm-3 ctbox ctl text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p05.png" alt="Korea" />
                            <p>Korea</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p06.png" alt="Australia" />
                            <p>Australia</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p07.png" alt="New Zealand" />
                            <p>New Zealand</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p08.png" alt="Malaysia" />
                            <p>Malaysia</p>
                        </div>
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-sm-3 ctbox ctl text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p09.png" alt="Indonesia" />
                            <p>Indonesia</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p03.png" alt="Brazil" />
                            <p>Brazil</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p11.png" alt="Germany" />
                            <p>Germany</p>
                        </div>
                        </div>
                        <div className="col-sm-3 ctbox text-danger">
                        <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p12.png" alt="UK" />
                            <p>UK</p>
                        </div>
                        </div>
                    </div>

                    <div className="ctbk">
                        <div className="row">
                        <div className="col-sm-4 ctbox ctl text-danger">
                            <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p13.png" alt="Ireland" />
                            <p>Ireland</p>
                            </div>
                        </div>
                        <div className="col-sm-4 ctbox text-danger">
                            <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p14.png" alt="France" />
                            <p>France</p>
                            </div>
                        </div>
                        <div className="col-sm-4 ctbox text-danger">
                            <div className="ct-content">
                            <img src="./serviceImg/ic_ct_p15.png" alt="The Netherlands" />
                            <p>The Netherlands</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                <div className="br mt100 mb100"></div>
                <div>
                    <div>
                        <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.3,
                            default: { ease: "linear" },
                        }}>
                        <div className="beckertitlename mt100 mb-5" id="qa">中文解題知識庫 & 中文線上發問系統</div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.5,
                            default: { ease: "linear" },
                        }}>
                        <div className="text-center w-50 m-auto">
                        USCPA 考試以電腦答題為主要作答形式， Becker CPA Exam Review 內建大量各式題庫，學員透過答題充分練習並建立答題題感，作答過程如有疑問可透過以下2種方式獲得解答：<br/>
                        一、透過「捷進官網【學員專區-中文線上發問系統】」進入題庫搜尋問題解析。<br/>
                        二、透過「捷進官網【學員專區-中文線上發問系統】 」以中文進行發問。<br/>
                        </div>
                        </motion.div>
                    </div>
                    <div className="br mt100 mb100"></div>
                    <div>
                        <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.3,
                            default: { ease: "linear" },
                        }}>
                        <div className="beckertitlename mt100 mb-5" id="whycpa">選擇美國註冊會計師 Why USCPA?</div>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.5,
                            default: { ease: "linear" },
                        }}>
                        <div className="text-center w-50 m-auto">
                        美國註冊會計師為全球會計專業類首選，人才需求遍佈各地跨國企業，是留學生申請 OPT、移民赴美工作者加分首選。USCPA 考試通過率高、準備期短，台灣在職考生平均九個月通過全科考試，即獲取執照；在校全職考生最快兩個月即通過全科。
                        USCPA 重觀念、不須死背，實際考試介面提供法規查詢與自動拼字檢查功能，不求考試技巧或背誦大量法條，目的在於強調與證明考生擁有解決客戶疑問的能力。
                        </div>
                        </motion.div>
                    </div>
                    <div className="br mt100 mb100"></div>
                    <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.3,
                            default: { ease: "linear" },
                        }}>
                    <div className="beckertitlename mt100 mb-5">選擇 Becker 準備美國會計師考試 Why Becker CPA?</div>
                    </motion.div>
                    <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.5,
                            default: { ease: "linear" },
                        }}>
                    <div className="text-center w-50 m-auto">
                    在「能力當道 + 講求迅速」的現今，每十個美國會計師之中，就有九個是使用 Becker 通過考試成功；90%獲 Elijah Watt Sells Award 的考生得主都是 Becker 學員。
        　
                    然而，北美地區華人考生可能受限於留美時間短、對專業英文與對英美法陌生之故，常在考試準備上無法有效率地達標。
                    </div>
                    </motion.div>
                    <div className="br mt100 mb100"></div>
                    <div className="beckertitlename mt100 mb-5" id="com">美國註冊會計師教材產品
                    與坊間方案比較表</div>
                    <div className="compare wcompare">
                        <table className="text-center">
                            <tr>
                                <td className="col-2">
                                    <div className="a1">產品功能</div>
                                </td>
                                <td className="col-2">
                                    <div className="a2">坊間</div>
                                </td>
                                <td className="col-3">
                                    <div className="a3">捷進 Becker</div>
                                </td>
                                <td className="col-3">
                                    <div className="a3">考生見證</div>
                                </td>
                                <td className="col-2">
                                    <div className="a3">見證全文</div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>通過率</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>N/A</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win" alt="win"/>
                                    </div>
                                    <div>連續16年屢創95%高分通過獎Watt Sells Award 冠軍</div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「傳說中的 Becker Bump 是真的存在，我的最後考試成績都比Becker 的模擬考多了20~30分。只要拿 Becker 教材來練習，假以時日，堅持到底，考取美國會計師真的不難。」<br/>
                                            —— Leon，2023年9月通過全科考試</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/561">獲獎佳績</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a5 formt" align="center" valign="top">
                                    <div>教材與真實考試相似度</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div>N/A</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win2" alt="win"/>
                                    </div>
                                    <div>由退休 U.S. CPA 考官組成研發團隊，模擬實際考試相似度近100%</div>
                                </td>
                                <td className="a5" align="left" valign="top" >
                                        「經過體驗教材 Becker，介面很容易上手，內容簡潔並且很多實用的重點整理，加上模擬試題介面與實際考試的介面相似，因此讓我在實際考試時更上手也更輕鬆。」
                                            <br/>—— Cherry，2023年6月通過全科考試<br/><br/>
                                    「我覺得Becker的題庫是真的跟實戰的時候很像，所以一定要認真檢討作題結果。」<br/>—— 薇薇安，2023年3月通過全科考試
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/517">Cherry</a><br/><br/><br/><br/><br/><a href="https://beckertw.com/art/494">薇薇安</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>師資</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>1人教四科</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win3" alt="win"/>
                                    </div>
                                    <div>各科由持該領域專業的10位中美講師聯合執教</div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「面授課程的收穫完全超乎我的期待，REG的律師老師幫助我釐清許多自己讀書時認知錯誤的概念，讓我 REG 有清楚架構而不是支離破碎東拼西湊的記憶，老師課後還耐心為同學解惑，真的很感謝老師。」
                                        <br/>—— Mia，東吳大學會計系應屆畢業生<br/><br/>
                                        「選擇法規與審計這兩科不再一集一集聽外師上課，決定上中文數位課程把這兩科加速讀完，事後證明，經由中師的講解，理解速度快了不少，同時上完中師的課，就直接寫一半的題目，答對率也十分不錯」
                                        <br/>—— Wogan Chang，2023年9月通過考試</div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/269">Mia</a><br/><br/><br/><br/><br/><br/><a href="https://beckertw.com/art/552">Wogan</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a5 formt" align="center" valign="top">
                                    <div>考試解題服務</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div>1人電郵回答</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win4" alt="win"/>
                                    </div>
                                    <div>1.Academic Support 美籍外師<br/>
                                        48小時內線上解答<br/>
                                        2.共5位中文老師老師不限次數回答<br/>
                                        3.近10年累積考題解答知識庫，<br/>
                                        關鍵字查詢任意歷史問答 Q&A
                                    </div>
                                </td>
                                <td className="a5" align="left" valign="top" >
                                    「非常推薦中文線上解題服務，能進行發問，也能在系統上看到過去考生與老師問答的過程，答覆都十分用心，這部分讓我獲益良多。」
                                    <br/>—— 林昱仁 ，2023年9月通過全科考試
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/556">林昱仁</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>流程諮詢服務<br/>
                                        <span>*皆針對購買中文全科者</span>
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>1個月1次<br/>
                                        每次30分鐘<br/>
                                        (限周末)
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win5" alt="win"/>
                                    </div>
                                    <div>不限次數，一週六天<br/>
                                        即時文字或通話諮詢
                                    </div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「相信考過美會的人一定能切身體會壓力來源不單單只是考試本身，還有繁瑣的報考流程、擔心申請文件出差錯等等，謝謝Becker 耐心協助我與美國會計師協會、學歷認證機構聯絡，並提供我以前學員遇過的問題並告訴我最佳路徑，省去我走錯路的時間及金錢。」
                                        <br/>—— 周同學，2023年3月通過全科考試
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/538">周同學</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a5 formt" align="center" valign="top">
                                    <div>方案永續性</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div>18個月即中止</div>
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win6" alt="win"/>
                                    </div>
                                    <div>至少24個月，且得免費延長<br/>至通過考試為止<br/>跟著 AICPA 公告即時更新教材
                                    </div>
                                </td>
                                <td className="a5" align="left" valign="top" >
                                    「完成報名及資格審核，卻因疫情及工作影響遲遲未能投入時間準備，考試及唸書計畫也一延再延... 謝謝 Becker 讓我不需要額外付費，畢竟離報名課程已超過兩年。」
                                    <br/>—— Ryan，2023年9月通過全科考試
                                </td>
                                <td className="a5" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/535">Ryan</a></div>
                                </td>
                            </tr>
                            <tr className="">
                                <td className="a4 formt" align="center" valign="top">
                                    <div>完備性<br/>
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div>目前僅3科
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div className="win_c">
                                        <img src="./serviceImg/win.png" className="win7" alt="win"/>
                                    </div>
                                    <div>
                                        斥資百萬美元研發全6科已上架上線
                                    </div>
                                </td>
                                <td className="a4" align="left">
                                    <div>「Becker 有長期輔導經驗，學程內容跟著考情更新 (更新資料頻率高，尤其更新項目一定要熟讀，就是考點！)，能有效率的成功通關。」
                                    <br/>—— Barry Hsieh，2023年11月通過考試
                                    </div>
                                </td>
                                <td className="a4" align="center" valign="top">
                                    <div><a href="https://beckertw.com/art/570">Barry Hsieh</a></div>
                                </td>
                            </tr>
                        </table>
                        <div className="text-left">以上見證文章與人名，皆獲學員本人授權公開刊登</div>
                        <div className="safe">
                            <img className="cheack"  src="./serviceImg/com_image_005.png" alt="com"/>
                            <div className="title2">
                                降低重考風險，Becker CPA 最保險
                            </div>
                            <div className="sub">
                                使用 Becker 達到 94% 考試通過率！ <a href="https://beckertw.com/art/326">(什麼是 Becker Bump?)</a>
                            </div>
                        </div>
                    </div>
                    <div className="row mcompare">
                        <div className="compare">
                            <table className="text-center">
                                <tr>
                                    <td nowrap="">
                                        <div className="a1">產品功能</div>
                                    </td>
                                    <td nowrap="">
                                        <div className="a2">坊間</div>
                                    </td>
                                    <td nowrap="">
                                        <div className="a3">捷進 Becker</div>
                                    </td>
                                    <td nowrap="">
                                        <div className="a3">考生見證</div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>通過率</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>N/A</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win" alt="win"/>
                                        </div>
                                        <div>連續16年屢創95%高分通過獎Watt Sells Award 冠軍</div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「傳說中的 Becker Bump 是真的存在，我的最後考試成績都比Becker 的模擬考多了20~30分。只要拿 Becker 教材來練習，假以時日，堅持到底，考取美國會計師真的不難。」<br/>
                                                —— 2023年9月通過全科考試<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/561">Leon</a></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a5 formt" align="center" valign="top">
                                        <div>教材與真實考試相似度</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div>N/A</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win2" alt="win"/>
                                        </div>
                                        <div>由退休 U.S. CPA 考官組成研發團隊，模擬實際考試相似度近100%</div>
                                    </td>
                                    <td className="a5" align="left" valign="top" >
                                            「經過體驗教材 Becker，介面很容易上手，內容簡潔並且很多實用的重點整理，加上模擬試題介面與實際考試的介面相似，因此讓我在實際考試時更上手也更輕鬆。」
                                                <br/>—— 2023年6月通過全科考試<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/517">Cherry</a><br/><br/>
                                        「我覺得Becker的題庫是真的跟實戰的時候很像，所以一定要認真檢討作題結果。」<br/>—— 2023年3月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/494">薇薇安</a>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>師資</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>1人教四科</div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win3" alt="win"/>
                                        </div>
                                        <div>各科由持該領域專業的10位中美講師聯合執教</div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「面授課程的收穫完全超乎我的期待，REG的律師老師幫助我釐清許多自己讀書時認知錯誤的概念，讓我 REG 有清楚架構而不是支離破碎東拼西湊的記憶，老師課後還耐心為同學解惑，真的很感謝老師。」
                                            <br/>—— 東吳大學會計系應屆畢業生<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/269">Mia</a><br/><br/>
                                            「選擇法規與審計這兩科不再一集一集聽外師上課，決定上中文數位課程把這兩科加速讀完，事後證明，經由中師的講解，理解速度快了不少，同時上完中師的課，就直接寫一半的題目，答對率也十分不錯」
                                            <br/>—— 2023年9月通過考試<a className="text-danger text-decoration-underline" href="https://beckertw.com/art/552">Wogan</a></div>

                                    </td>
                                    <td className="a4" align="center" valign="top">
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a5 formt" align="center" valign="top">
                                        <div>考試解題服務</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div>1人電郵回答</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win4" alt="win"/>
                                        </div>
                                        <div>1.Academic Support 美籍外師<br/>
                                            48小時內線上解答<br/>
                                            2.共5位中文老師老師不限次數回答<br/>
                                            3.近10年累積考題解答知識庫，<br/>
                                            關鍵字查詢任意歷史問答 Q&A
                                        </div>
                                    </td>
                                    <td className="a5" align="left" valign="top" >
                                        「非常推薦中文線上解題服務，能進行發問，也能在系統上看到過去考生與老師問答的過程，答覆都十分用心，這部分讓我獲益良多。」
                                        <br/>—— 2023年9月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/556">林昱仁</a>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>流程諮詢服務<br/>
                                            <span>*皆針對購買中文全科者</span>
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>1個月1次<br/>
                                            每次30分鐘<br/>
                                            (限周末)
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win5" alt="win"/>
                                        </div>
                                        <div>不限次數，一週六天<br/>
                                            即時文字或通話諮詢
                                        </div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「相信考過美會的人一定能切身體會壓力來源不單單只是考試本身，還有繁瑣的報考流程、擔心申請文件出差錯等等，謝謝Becker 耐心協助我與美國會計師協會、學歷認證機構聯絡，並提供我以前學員遇過的問題並告訴我最佳路徑，省去我走錯路的時間及金錢。」
                                            <br/>—— 2023年3月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/538">周同學</a></div>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a5 formt" align="center" valign="top">
                                        <div>方案永續性</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div>18個月即中止</div>
                                    </td>
                                    <td className="a5" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win6" alt="win"/>
                                        </div>
                                        <div>至少24個月，且得免費延長<br/>至通過考試為止<br/>跟著 AICPA 公告即時更新教材
                                        </div>
                                    </td>
                                    <td className="a5" align="left" valign="top" >
                                        「完成報名及資格審核，卻因疫情及工作影響遲遲未能投入時間準備，考試及唸書計畫也一延再延... 謝謝 Becker 讓我不需要額外付費，畢竟離報名課程已超過兩年。」
                                        <br/>—— 2023年9月通過全科考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/535">Ryan</a>
                                    </td>
                                </tr>
                                <tr className="">
                                    <td className="a4 formt" align="center" valign="top">
                                        <div>完備性<br/>
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div>目前僅3科
                                        </div>
                                    </td>
                                    <td className="a4" align="center" valign="top">
                                        <div className="win_c">
                                            <img src="./serviceImg/win.png" className="win7" alt="win"/>
                                        </div>
                                        <div>
                                            斥資百萬美元研發全6科已上架上線
                                        </div>
                                    </td>
                                    <td className="a4" align="left">
                                        <div>「Becker 有長期輔導經驗，學程內容跟著考情更新 (更新資料頻率高，尤其更新項目一定要熟讀，就是考點！)，能有效率的成功通關。」
                                        <br/>—— 2023年11月通過考試
                                        <a className="text-danger text-decoration-underline" href="https://beckertw.com/art/570">Barry Hsieh</a></div>
                                    </td>
                                </tr>
                            </table>
                            <div className="text-right">以上見證文章與人名，皆獲學員本人授權公開刊登</div>
                            <div className="safe">
                                <img className="cheack" src="./serviceImg/com_image_005.png" alt="com"/>
                                <div className="title2">
                                    降低重考風險，Becker CPA 最保險
                                </div>
                                <div className="sub">
                                    使用 Becker 達到 94% 考試通過率！ <a href="https://beckertw.com/art/326">(什麼是 Becker Bump?)</a>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div className="br mt100 mb100"></div>
                    <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.3,
                            default: { ease: "linear" },
                        }}>
                    <div className="beckertitlename mt100 mb-5">選擇 Becker 台灣雙語課程與諮詢方案 Why Taiwan Becker CPA?</div>
                    </motion.div>
                    <motion.div
                            initial={{ opacity: 0, x:-100 }}
                            whileInView={{ opacity: 1, x:0 }}
                            transition={{
                            delay: 0.5,
                            default: { ease: "linear" },
                        }}>
                    <div className="text-center w-75 m-auto">
                        Becker Taiwan 自2003年起，即推廣研發中文與英文雙語解說課程，協助跨科系、對英美法及專業英文陌生的華語考生們，快速理解並成功通過 USCPA 考試。Becker Taiwan 的 CPA 考生學員通過率高，2016 更獲 AICPA 高分肯定獎項 Elijah Watt Sells Award。在英語非母語的台灣，學員能獲有此殊榮，與台灣中文講師的精湛教學不無關係。
            　
                        Becker Taiwan 的 CPA 六科中文課程，皆聘請在該科領域上獨具專業背景的美國會計師。舉例來說，Regulation 科目講師亦持有美國律師資格；同時，內含大量資訊科技內容的 ISC 科目，授課講師即為 IT 專業背景的美國會計師。
            　
                        此外值得一提的是，Becker Taiwan 的 CPA 學員可獲得線上中文解題服務、使用中文解答知識庫、以及報名申請考試的行政手續全程輔導。
                    </div>
                    </motion.div>
                </div>
            </div>
            
            <div className="container mt100">
                <div className="br mt100 mb100"></div>
                <div className="row">
                    <div className="col-6 coursevideo">
                        <div className="text-left mb-2">
                            全新專科「Business Analytics & Reporting (BAR)」第一單元，中文課前導讀 (試聽影片)
                        </div>
                        <iframe className="dis" width="560" height="315" src="https://www.youtube.com/embed/IM8PBAEKVD0?si=X7Q9V89NrbOzo2oj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <iframe className="mvideo" width="400" height="200" src="https://www.youtube.com/embed/IM8PBAEKVD0?si=X7Q9V89NrbOzo2oj" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                    <div className="col-6 coursevideo">
                        <div className="text-left mb-2">
                            全新專科「Information Systems & Control 資訊系統與控制 (ISC)」第一堂課，中文課前導讀 (試聽影片)
                        </div>
                        <iframe className="dis" width="560" height="315" src="https://www.youtube.com/embed/7JDSmkPRROs?si=rwxgZvvBxGuRh7YI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                        <iframe className="mvideo" width="400" height="200" src="https://www.youtube.com/embed/7JDSmkPRROs?si=rwxgZvvBxGuRh7YI" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="br mt100 mb100"></div>
                <div className="beckertitlename mt100 mb-5">選擇現在啟動考照計畫 Now is the time</div>
                <div className="text-center w-50 m-auto">
                    Becker Taiwan 即日起擴增 CPA 雙語課程（比 Becker 原文教材更多出約120小時之中文強化講解課程）以及上述貼心服務至北美及新加坡、香港、日本等地區，開放華人考生跨洋線上學習與使用。
                    想要快速通過考試取得美國會計師執照的華人考生，現在就是最好的啟動時機！
                    　
                    Becker Taiwan 現行優惠方案，讓您使用 Becker CPA 及中文雙語輔考課程教材，可持續展延使用期限，展延直到考上為止；您可自由任選時段於雲端看課，讓業界經驗豐富的中文 USCPA 講師，帶您入門美國商稅法、資訊科技、政府會計等會計本科都不一定修過的範疇，搭配講師系統整理之精華重點講義；您可全程在線上上課，且依個人需要隨選隨看。
                    　
                    把握 2024 考試黃金準備期，取得「不是工作選我，而是我來挑工作」的鍍金籌碼：準備USCPA，就是現在！
                </div>
                <div className="br mt100 mb100"></div>
            </div>
            
            <div className="beckertitlename mt100 mb100" id="intro">捷進 Becker CPA方案介紹</div>
            
            <div className="container">
                <div className="row mt100">
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>專業方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li className="text-danger">考程顧問諮詢輔導</li>
                                    <li className="text-danger"> 執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元優惠價)</li>
                                    <li className="text-danger">CPA Final Review 軟體</li>
                                    <li className="text-danger">完整四科中文課程</li>
                                    <li className="text-danger">中文線上單元導讀影片</li>
                                    <li className="text-danger">中文線上解題服務</li>
                                    <li className="text-danger">CPE Select 一年份執照進修課程</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月+<span className="text-danger">持續展延</span></span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>帶職、在學備考者<br/>
                                並使用中文課程與線上解題服務</span>
                            </div>
                            <div className="cash">120,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>全修方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li className="text-danger">考程顧問諮詢輔導</li>
                                    <li className="text-danger"> 執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元優惠價)</li>
                                    <li className="text-danger">CPA Final Review 軟體</li>
                                    <li className="text-danger">完整四科中文課程</li>
                                    <li className="text-danger">中文線上單元導讀影片</li>
                                    <li className="text-danger">中文線上解題服務</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月+<span className="text-danger">持續展延</span></span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>帶職、在學備考者<br/>
                                並使用中文課程與線上解題服務</span>
                            </div>
                            <div className="cash">113,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>選修方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li className="text-danger">三次考程顧問諮詢輔導</li>
                                    <li className="text-danger">執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元優惠價)</li>
                                    <li className="text-danger">任選6堂中文課程</li>
                                    <li className="text-danger">CPA Final Review 軟體</li>
                                    <li className="text-danger">All In One 國際就業力課程</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月</span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>留學生、僅須重點中文課程者</span><br/>
                            </div>
                            <div className="cash">80,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container mt100">
                <div className="row">
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>自修方案</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月</span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>留學生、全自修者<br/>
                                並使用中文課程與線上解題服務</span>
                            </div>
                            <div className="cash">75,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>單科雙語</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>CPA Exam Review 學習題庫軟體 (含 Flashcards)</li>
                                    <li>英文線上解題 (Academic Support)</li>
                                    <li>單科中文課程</li>
                                </ul>
                            </div>
                            <div className="ugbk">
                                <h6>使用效期</h6>
                                <span>24個月</span>
                            </div>
                            <div className="ugbk">
                                <h6>適用客群</h6>
                                <span>已通過部分科目者</span>
                            </div>
                            <div className="cash">45,000</div>
                            
                            <Link to={`/registration?parent_id=1`} className="bt_prd">»報名與購買</Link>
                        </div>
                    </div>
                    <div className="col-4 pricecard">
                        <div className="card pdbox w-75 h-100">
                            <h5>購買方式</h5>
                            <div className="card-body">
                                <ul className="align-items-stretch">
                                    <li>點選套組下方「了解更多」，即可查看線上報名表。</li>
                                    <li>欲購買教材並報名課程，請填寫報名表並依說明完成匯款；我們在收到表單資料後，將有專人於當日與您聯絡。</li>
                                </ul>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="beckertitlename mt100 mb-5">甚麼是持續展延？</div>
            <div className="text-center w-50 m-auto mb100">
            Becker 公定使用效期為24個月，到期時若有尚未通過的科目，告知 Becker，即可免費展延該科目的使用效期。<br/>
            每次免費展延6個月，可無限次展延，直到通過該科考試為止。<br/>
            <span className="text-danger">以上加值服務之項目與內容，本公司將保留變更、終止、修改及解釋之權利。</span>
            <div className="br mt100 mb100"></div>
            </div>
            <div className="container-fluid wt xx_pc">
                <div className="beckertitlename mt100"  id="twus">台灣與美國<br/>
                    購買Becker教材比較</div>
                <div className="row adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl titcp">
                            <br/> 美國/USA
                        </div>
                    </div>
                    <div className="col-sm-2 cpit cpt titcp">v.s.</div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr titcp">
                            <br/> 台灣/TAIWAN
                        </div>
                    </div>
                </div>
                <div className="row cpe adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            Becker CPA Exam Review
                            <br/> 培訓軟體
                        </div>
                    </div>
                    <div className="col-sm-2 cpit cpt">產
                        <br/>品
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr">Becker CPA Exam Review
                            <br/> 培訓軟體
                        </div>
                    </div>
                </div>
                <div className="row cpe eg adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> USD 2,499
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epg cpt">價
                        <br/>格
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="egs">★★★★★</span>
                            <br/> NTD 113,000
                            <br/>
                            <span className="red">售價與美國同步，再贈中文加值服務</span>
                        </div>
                    </div>
                </div>
                <div className="row cpe eb adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> 美籍全英語教學
                            <br/> 四科
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epb cpt">授
                        <br/>課
                        <br/>方
                        <br/>式
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="ebs">★★★★★</span>
                            <br/> 美籍全英語教學
                            <br/> 四科
                            <br/>
                            <span className="red">四科中文精華課程 + 全科中文雲端導讀</span>
                        </div>
                    </div>
                </div>
                <div className="row cpe ed adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> 無
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epd cpt">顧
                        <br/>問
                        <br/>諮
                        <br/>詢
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="eds">★★★★★</span>
                            <br/>
                            <span className="red">考程 3 階段顧問諮詢與文件檢核服務：<br/>
                                ◆ 學歷認證、報名考試、預約考場<br/>
                                通過考試後，依學員需求可預約：<br/>
                                ◆ 執照申請與台會抵免諮詢 (1小時 5,000元；提供備考經驗分享得2,000元減免)</span>
                        </div>
                    </div>
                </div>
                <div className="row cpe ex adt">
                    <div className="col-sm-5 cpm">
                        <div className="cpl">
                            <br/> Academic Support 軟體線上發問系統
                            <br/> 48小時英文解題回覆服務
                        </div>
                    </div>
                    <div className="col-sm-2 cpit epx cpt">解
                        <br/>題
                        <br/>服
                        <br/>務
                    </div>
                    <div className="col-sm-5 cpm">
                        <div className="cpr"><span className="exs">★★★★★</span>
                            <br/> Academic Support 軟體線上發問系統
                            <br/> 48小時英文解題回覆服務
                            <br/>
                            <span className="red">中文解題知識庫：進入題庫搜尋問題解析<br/>
                                中文解題知識庫：進入題庫搜尋問題解析<br/>
                                中文線上發問系統：中文發問、中文回覆
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <section className="plan-compare d-none d-md-block">
            <div className="beckertitlename mt100 mb100">方案比較</div>
            <div className="container mb100">
                <div className="row">
                    <div className="compare" >
                        <table className="text-center">
                            <tr>
                                <td nowrap="">
                                    <div className="a1">專業方案</div>
                                </td>
                                <td nowrap="">
                                    <div className="a1">全修方案</div>
                                </td>
                                <td nowrap="">
                                    <div className="a1">選修方案</div>
                                </td>
                                <td nowrap="">
                                    <div className="a1">自修方案</div>
                                </td>
                            </tr>
                            <tr className="xxx-hide">
                                <td colspan="5">
                                    <div className="a2">適合客群</div>
                                </td>
                            </tr>
                            <tr className="xxx-hide">
                                <td className="a3" align="left" valign="top">
                                    <div>以取得執照為目標的財務會計業界人士</div>
                                </td>
                                <td className="a3" align="left" valign="top">
                                    <div>習慣搭配中文學習輔助、與同儕切磋、節省自行摸索時間、避免繁瑣手續者</div>
                                </td>
                                <td className="a3" align="left" valign="top">
                                    <div>仍在職或在學、僅需重點單元的中文課程、欲節省自行摸索時間、避免繁瑣手續者</div>
                                </td>
                                <td className="a3" align="left" valign="top">
                                    <div>有自信短期內通過考試、不需中文課程者</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">CPA Exam Review 學習軟體</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">100+ 小時美師授課影片（英字幕）</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">1300 電子閃字卡 (Flashcards)</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">6,700+ 練習題庫</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">3 套期中考 + 2 套模擬考 </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">70+ 小時美師解題影片（英文字幕）</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">四本 Exam Review 紙本教科書</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">外師線上解題服務 (英文)</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">CPA Final Review 總複習軟體</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">35+ 小時美師總複習影片（英文字幕）</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">800+ 總複習練習題庫</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">1 套全真模擬考 </div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">考程顧問諮詢輔導</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">三次</div>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">中文課程（實體面授、實體數位、雲端觀看）</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">4科</div>
                                </td>
                                <td>
                                    <div className="a3">4科</div>
                                </td>
                                <td>
                                    <div className="a3">6堂</div>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">中師線上解題服務 (中文)</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">30+ 小時中師導讀與解題影片</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">All In One 國際就業力線上課程</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">執照延續進修課程 CPE 一年份訂閱</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3">✔</div>
                                </td>
                                <td>

                                </td>
                                <td>

                                </td>
                                <td>

                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">軟體效期</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp1">24個月</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp2">24個月</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">24個月</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">24個月</a></div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp1">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp2">✔</a></div>
                                </td>
                                <td>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">方案定價</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp1">NT$120,000</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp2">NT$113,000</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">NT$80,000</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">NT$75,000</a></div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="compare">
                        <table className="text-center">
                            <tr className="xxx-hide">
                                <td colspan="5">
                                    <div className="a1">Becker Taiwan 學員專屬加購功能</div>
                                </td>
                            </tr>
                            <tr>
                                <td nowrap="">
                                    <div className="a1">專業方案</div>
                                </td>
                                <td nowrap="">
                                    <div className="a1">全修方案</div>
                                </td>
                                <td nowrap="">
                                    <div className="a1">選修方案</div>
                                </td>
                                <td nowrap="">
                                    <div className="a1">自修方案</div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">可付費或是提供心得文享優惠減免申請取照諮詢</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp1">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp2">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">✔</a></div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">可加購中文課程堂數</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp1">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp2">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">✔</a></div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">可選修加州州立大學合作學分班</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp1">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp2">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">✔</a></div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">可加購持續展延 Unlimited Access</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                </td>
                                <td>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">✔</a></div>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">可加購 Final Review 總複習</div>
                                </td>
                            </tr>
                            <tr>
                            <td>
                            </td>
                            <td>
                            </td>
                            <td>
                                <div className="a3"><a href="#pp3">✔</a></div>
                            </td>
                            <td>
                                <div className="a3"><a href="#pp4">✔</a></div>
                            </td>
                            </tr>
                            <tr>
                                <td colspan="5">
                                    <div className="a2">購買 CMA (美國管理會計師) 享學員優惠</div>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp3">✔</a></div>
                                </td>
                                <td>
                                    <div className="a3"><a href="#pp4">✔</a></div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            
            <div className="container-fluid ueit">
                <div className="marbk width_c">
                    <h3>最適合華人考生的備考方案</h3>
                    購買 Becker Taiwan CPA 全修方案，即可獲得 四科中文課程使用額度，可於軟體有效期間於 Becker Taiwan 中文雲端教室隨選隨看，再加贈40小時額外補課用時數，
                    更可於線上解題專區，向台灣講師發問、獲得中文解題，亦可隨時搜尋歷史問答解題資料庫，獲得相關解題說明；
                    中文課程為 Becker Taiwan 專聘持有美國會計師/美國律師資格之台灣在職資深講師，所開設之精華衝刺課程，同時搭配可使用至考上為止之 Becker CPA Exam 教材軟體、美師完整授課影片 (中英字幕)、7,000+題庫、3套全真模擬考試、美師線上解答，另含報考行政流程完整諮詢輔導服務。
                </div>
            </div>
            </section>
        </>
    );
}
export default Service;